/**
* @author lmcarrillo <lmcarrillo@sergas.net>
* @copyright Boqueixon 2023
* @version 20.60.60
* @license licenses.txt
*
* @date 2023-03-19 12:47:49
**/

import { Component , OnInit } from "@angular/core";
import { Router, Event, NavigationStart, NavigationEnd, NavigationError } from "@angular/router";
import { StatusBar } from "@ionic-native/status-bar/ngx";
import { environment } from "./../../../../src/environments/environment";
import { TranslateService } from "@ngx-translate/core";
import { Storage } from "@ionic/storage";
import { Globals } from "../../class/globals/globals";
import { TranslateConfiguration } from "../../class/translate-configuration/translate-configuration";
import { Observable } from "rxjs";
import { PopoverController } from "@ionic/angular";
import { PopoverComponent } from "../../components/popover/popover.component";



@Component({
	selector: "app-bookmarks",
	templateUrl: "bookmarks.page.html",
	styleUrls: ["bookmarks.page.scss"],
})

export class BookmarksPage {
	
	pageName:string = `bookmarks` ;
	
	/**
	* BookmarksPage:constructor()
	**/
	constructor(
		private router: Router,
		public statusBar: StatusBar,
		public translateService: TranslateService,
		public popoverController: PopoverController,
		private storage: Storage,
		private globals: Globals,
		private translateConfiguration: TranslateConfiguration
	){
	
		// statusbar
		this.statusBar.styleLightContent();
		this.statusBar.overlaysWebView(false);
		this.statusBar.backgroundColorByHexString("#e6e6e6");
	
		// translate
		this.translateConfiguration.setDefaultLanguage();

	
	
		//badge for bookmarks
		this.createBadge();
		

		console.log(`BookmarksPage`,`pageName`,this.pageName);
	}
	
	/**
	* BookmarksPage:showPopover()
	**/
	async showPopover(ev: any) {
		const popover = await this.popoverController.create({
			component: PopoverComponent,
			event: ev,
			translucent: true
		});
		return await popover.present();
	}
	
	


		
	dataBookmarks : any = [];
	
	
	/**
	* BookmarksPage.setItem(table,key,value)
	**/
	public async getItem(table:string,key:string,value:any){
		return this.storage.get(`${table}:${key}`).then((data)=>{return data})
	}
	
	
	/**
	* BookmarksPage.setItem(table,key,value)
	**/
	public setItem(table:string,key:string,value:any){
		return this.storage.set(`${table}:${key}`,value);
	}
	
	
	/**
	* BookmarksPage.getItems(table)
	**/
	items : any = []; 
	public async getItems(table:string){
		this.items = []; 
		this.storage.forEach((iValue, iKey, iIndex) => {
			let prefix : string = `${table}:`;
			if(iKey.substring(0,prefix.length) ==  prefix){
				this.pushItem(iValue);
			}
		});
	}
	
	
	/**
	* BookmarksPage.pushItem(item)
	**/
	private pushItem(item){
		this.items.push(item);
	}
	
	
	/**
	* BookmarksPage.removeItem()
	**/
	public async removeItem(table:string,key:string){
		return await this.storage.remove(`${table}:${key}`);
	}
	
	
	/**
	* BookmarksPage.clearItems(table:string)
	**/
	public clearItems(table:string) {
		this.storage.forEach((iValue, iKey, iIndex) => {
			let prefix : string = `${table}:`;
			if(iKey.substring(0,prefix.length) ==  prefix){
				this.storage.remove(`${iKey}`);
			}
		});
	}
	
	
	/**
	* BookmarksPage.ngOnInit()
	**/
	public ngOnInit(){
		this.getItems(`bookmarks`);
		this.dataBookmarks = this.items;
	}
	
	
	/**
	* BookmarksPage.removeBookmark()
	**/
	public removeBookmark(id:string){
		this.removeItem(`bookmarks`,id);
		this.getItems(`bookmarks`);
		this.dataBookmarks = this.items;
	}
	
	
	/**
	* BookmarksPage.clearBookmark()
	**/
	public clearBookmark(){
		this.clearItems(`bookmarks`);
		setTimeout(() => {
			this.getItems(`bookmarks`);
			this.dataBookmarks = this.items;
		}, 2000);
	}
	
	
	/**
	* BookmarksPage.doRefresh()
	**/
	public doRefresh(refresher){
		this.getItems(`bookmarks`);
		this.dataBookmarks = this.items;
		setTimeout(() => {
			refresher.target.complete();
		}, 2000);
	}
	
	
	//create badge on tab menu
	count_bookmarks:number = 0;
	temp_count_bookmarks:number = 0 ;
	item_bookmarks : any = [];
	
	runBadge: any;
	
	
	/**
	* BookmarksPage:createBadge()
	**/
	createBadge(){
		this.runBadge = setInterval(()=>{
			this.getBadges();
		},1000)
	}
	
	
	/**
	* BookmarksPage:ionViewDidLeave()
	**/
	ionViewDidLeave(){
		clearInterval(this.runBadge);
	}
	
	
	/**
	*  BookmarksPage.getBookmark()
	**/
	public async getBookmark(){
		this.count_bookmarks = this.temp_count_bookmarks;
		this.temp_count_bookmarks = 0;
		this.item_bookmarks = []; 
		this.storage.forEach((iValue, iKey, iIndex) => {
			if(iKey.substring(0,10) ==  `bookmarks:`){
				this.pushBookmark(iValue);
			}
		});
	}
	
	
	/**
	* BookmarksPage.pushBookmark(item)
	**/
	private pushBookmark(item){
		this.temp_count_bookmarks++;
		this.item_bookmarks.push(item);
	}
	
	
	/**
	* BookmarksPage:getBadges()
	**/
	getBadges(){
		this.getBookmark();
	}
	
	




}
